export const getNodeImageSequence = (node) => {
    const sequence = Number(
        node?.data?.imageSequence
        ?? node?.renderData?.data?.imageSequence
        ?? 0,
    );
    return Number.isFinite(sequence) && sequence > 0 ? sequence : 0;
};

export const getImageSequenceLabel = (sequence) => {
    const normalizedSequence = Number(sequence ?? 0);
    return Number.isFinite(normalizedSequence) && normalizedSequence > 0
        ? `图${normalizedSequence}`
        : '';
};

export const isDefaultImageSequenceLabel = (label = '') => (
    /^图\s*\d+$/.test(String(label || '')) || /^Image\s*\d+$/.test(String(label || ''))
);

export const withNodeImageSequence = (node, imageSequence) => {
    if (!node || node.type === 'groupNode') return node;

    const nextSequence = Number(imageSequence ?? 0);
    if (!Number.isFinite(nextSequence) || nextSequence <= 0) return node;

    const nextLabel = getImageSequenceLabel(nextSequence);
    const currentImageSequenceLabel = node.data?.imageSequenceLabel;
    const currentNodeLabel = node.data?.label || '';
    const shouldOverrideImageNodeLabel = !currentNodeLabel || isDefaultImageSequenceLabel(currentNodeLabel);

    return {
        ...node,
        data: {
            ...(node.data || {}),
            ...(node.type === 'imageNode' && shouldOverrideImageNodeLabel ? { label: nextLabel } : {}),
            imageSequence: nextSequence,
            imageSequenceLabel: currentImageSequenceLabel || nextLabel,
        },
    };
};

export const parseLabelSequence = (label, prefix) => {
    if (typeof label !== 'string') return 0;

    const pattern = new RegExp(`^${prefix}\\s*(\\d+)$`);
    const match = label.match(pattern);
    return match ? Number(match[1]) : 0;
};

export const getNextNodeImageSequenceNumber = (nodes) => (
    nodes.reduce((max, node) => (
        Math.max(
            max,
            getNodeImageSequence(node),
            parseLabelSequence(node.data?.label, '图'),
            parseLabelSequence(node.data?.label, 'Image'),
        )
    ), 0) + 1
);

export const normalizeNodeImageSequences = (nodes) => {
    let nextSequence = 1;
    const usedSequences = new Set();

    return (nodes || []).map((node) => {
        if (!node || node.type === 'groupNode') return node;

        const currentSequence = getNodeImageSequence(node)
            || parseLabelSequence(node.data?.label, '图')
            || parseLabelSequence(node.data?.label, 'Image');
        const assignedSequence = (
            currentSequence > 0 && !usedSequences.has(currentSequence)
        )
            ? currentSequence
            : nextSequence;
        usedSequences.add(assignedSequence);
        nextSequence = Math.max(nextSequence, assignedSequence + 1);

        return withNodeImageSequence(node, assignedSequence);
    });
};

export const getRestoredGroupNodeNumber = (nodes) => (
    nodes.reduce((max, node) => (
        Math.max(max, parseLabelSequence(node.data?.label, 'Group'))
    ), 0) + 1
);